import { IconProps } from '@/types/icons';

function SignUpIcon(props: IconProps) {
  return (
    <svg width="12" height="18" viewBox="0 0 12 18" fill="none" {...props}>
      <path
        d="M10.875 14.625H7.875"
        stroke="#1C2024"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.375 16.125V13.125"
        stroke="#1C2024"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.12001 8.1525C6.04501 8.145 5.95501 8.145 5.87251 8.1525C4.08751 8.0925 2.67001 6.63 2.67001 4.83C2.66251 2.9925 4.15501 1.5 5.99251 1.5C7.83001 1.5 9.32251 2.9925 9.32251 4.83C9.32251 6.63 7.89751 8.0925 6.12001 8.1525Z"
        stroke="#1C2024"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.9925 16.3574C4.6275 16.3574 3.27 16.0124 2.235 15.3224C0.419999 14.1074 0.419999 12.1274 2.235 10.9199C4.2975 9.53989 7.68 9.53989 9.7425 10.9199"
        stroke="#1C2024"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SignUpIcon;
